export enum AwardingBodyIdentifiers {
  Edexcel = 2,
  CIE = 4,
  AQA = 5,
}
